import React,{ createContext, useContext, useState, useEffect} from "react";
import axios from "axios";
import { baseUrl } from "../../api/common";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {


    const [websiteName, setWebsiteName] = useState("AMASI");
    const [websiteLogo, setWebsiteLogo] = useState("");
    const [razorpayKey, setRazorpayKey] = useState("rzp_test_0VhW5kvbe3uCFF");


    const [settingsDetails, setSettingsDetails] = useState({});

    const fetchSettingsDetails = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/settings`,{
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
  
        if (response.data.status) {
          const details = response.data.data[0];
          setWebsiteName(details.website_name);
          setWebsiteLogo(`${details.logo}`);
          setSettingsDetails(details);
          setRazorpayKey(details.razor_key_id);
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };

      useEffect(() => {
        fetchSettingsDetails();
      }, []);

    return (
        <SettingsContext.Provider value={{razorpayKey, websiteName, websiteLogo}}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
